import { useState } from "react";
import { Link } from "react-router-dom";
import { PlusCircle, Lock } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useSubscription } from "@/contexts/SubscriptionContext";
import { useBuyer } from "@/contexts/BuyerContext";
import { useAuth } from "@/contexts/AuthContext";
import SellerUpgradeDialog from "@/components/seller/SellerUpgradeDialog";

export const RestrictedActiveDealsHeader = () => {
  const { subscriptionStatus } = useSubscription();
  const { isBuyer } = useBuyer();
  const { profile } = useAuth();
  const [showUpgradeDialog, setShowUpgradeDialog] = useState(false);
  
  // Only show for sellers (not buyers, has seller profile) with expired status
  const isSeller = !isBuyer && profile;
  const isSellerExpired = isSeller && subscriptionStatus === 'expired';

  const handleNewDealClick = () => {
    if (isSellerExpired) {
      setShowUpgradeDialog(true);
    }
  };

  return (
    <>
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">
        <div>
          <h1 className="text-2xl font-bold tracking-tight">Active Deals</h1>
          <p className="text-muted-foreground">Manage your current property listings</p>
        </div>
        
        {isSellerExpired ? (
          <Button 
            onClick={handleNewDealClick}
            className="bg-godyspo-gold text-black hover:bg-godyspo-gold/90 opacity-60 cursor-not-allowed"
          >
            <Lock className="mr-2 h-4 w-4" />
            New Deal
          </Button>
        ) : (
          <Button asChild className="bg-godyspo-gold text-black hover:bg-godyspo-gold/90">
            <Link to="/seller/properties/new">
              <PlusCircle className="mr-2 h-4 w-4" />
              New Deal
            </Link>
          </Button>
        )}
      </div>
      
      <SellerUpgradeDialog 
        open={showUpgradeDialog} 
        onOpenChange={setShowUpgradeDialog}
        featureName="Upload New Deal"
      />
    </>
  );
};